import { render, staticRenderFns } from "./DocuformsList.vue?vue&type=template&id=0a6aa185&scoped=true"
import script from "./DocuformsList.vue?vue&type=script&lang=js"
export * from "./DocuformsList.vue?vue&type=script&lang=js"
import style0 from "./DocuformsList.vue?vue&type=style&index=0&id=0a6aa185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6aa185",
  null
  
)

export default component.exports